import { Injectable } from '@angular/core';

import { AfterShip } from 'aftership';
import { from, Observable, shareReplay, take } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AftershipService {
  aftership = new AfterShip(environment.aftership.token);

  courriers$ = from(this.aftership.courier.listCouriers()).pipe(shareReplay(1));

  constructor() {}
}
